import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PlatformLocation } from "@angular/common";

@Component({
    selector: "app-plan-summary-modal",
    templateUrl: "./plan-summary-modal.component.html",
    styleUrls: ["./plan-summary-modal.component.scss"],
    standalone: false,
})
export class PlanSummaryModalComponent {
    @Input() assets: Array<{ label: string; value: string }> = [];

    constructor(
        public activeModal: NgbActiveModal,
        private location: PlatformLocation,
    ) {
        location.onPopState(() => activeModal.close());
    }
}
